import { render, staticRenderFns } from "./VueSlickCarousel.vue?vue&type=template&id=57be7ce0&scoped=true&lang=pug&"
import script from "./VueSlickCarousel.vue?vue&type=script&lang=js&"
export * from "./VueSlickCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VueSlickCarousel.vue?vue&type=style&index=0&id=57be7ce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57be7ce0",
  null
  
)

export default component.exports